// src/pages/Pricing.jsx
import { useContext } from "react";
import { Helmet } from "react-helmet";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Container,
  Grid,
  Paper,
  Typography,
  Button,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import { LanguageContext } from "../context/LanguageContext";

const tiers = [
  {
    nameKey: "TierFreeName",
    priceKey: "TierFreePrice",
    featureKeys: [
      "TierFreeFeature1",
      "TierFreeFeature2",
      "TierFreeFeature3",
      "TierFreeFeature4",
    ],
    buttonKey: "TierFreeButton",
    buttonVariant: "outlined",
    to: "/login",
  },
  {
    nameKey: "TierPremiumName",
    priceKey: "TierPremiumPrice",
    featureKeys: [
      "TierPremiumFeature1",
      "TierPremiumFeature2",
      "TierPremiumFeature3",
      "TierPremiumFeature4",
      "TierPremiumFeature5",
    ],
    buttonKey: "TierPremiumButton",
    buttonVariant: "contained",
    to: "/login",
  },
];

export default function Pricing() {
  const { translate } = useContext(LanguageContext);

  return (
    <>
      <Helmet>
        <title>{translate("PricingPageTitle")}</title>
        <meta name="description" content={translate("PricingPageMeta")} />
      </Helmet>

      <Box sx={{ py: 8, px: { xs: 2, md: 0 } }}>
        <Container maxWidth="lg">
          <Typography variant="h4" fontWeight={700} align="center" gutterBottom>
            {translate("PricingTitle")}
          </Typography>
          <Typography
            variant="subtitle1"
            align="center"
            color="text.secondary"
            gutterBottom
          >
            {translate("PricingSubtitle")}
          </Typography>

          <Grid
            container
            spacing={4}
            sx={{ mt: 4 }}
            justifyContent="center"
          >
            {tiers.map((t) => (
              <Grid
                key={t.nameKey}
                item
                xs={12}
                md={5}
                lg={4}
                sx={{ display: "flex", justifyContent: "center" }}
              >
                <Paper
                  sx={{
                    p: 4,
                    borderRadius: 2,
                    textAlign: "center",
                    width: "100%",
                    maxWidth: 420,
                    boxShadow:
                      t.nameKey === "TierPremiumName"
                        ? "0px 10px 30px rgba(0,0,0,0.1)"
                        : "none",
                    border:
                      t.nameKey === "TierFreeName"
                        ? "1px solid #E0E0E0"
                        : "none",
                  }}
                >
                  <Typography variant="h6" fontWeight={600}>
                    {translate(t.nameKey)}
                  </Typography>
                  <Typography variant="h3" color="primary" sx={{ my: 2 }}>
                    ${translate(t.priceKey)}
                    {translate(t.priceKey) !== "0" && (
                      <Typography component="span" fontSize="1.2rem">
                        /mo
                      </Typography>
                    )}
                  </Typography>

                  <List dense sx={{ textAlign: "left" }}>
                    {t.featureKeys.map((fk) => (
                      <ListItem key={fk}>
                        <ListItemText primary={translate(fk)} />
                      </ListItem>
                    ))}
                  </List>

                  <Button
                    component={RouterLink}
                    to={t.to}
                    variant={t.buttonVariant}
                    size="large"
                    sx={{
                      mt: 3,
                      textTransform: "none",
                      ...(t.nameKey === "TierPremiumName" && {
                        background:
                          "linear-gradient(90deg, #D0BFFF 0%, #F9F2FF 100%)",
                        color: "#000",
                      }),
                    }}
                  >
                    {translate(t.buttonKey)}
                  </Button>
                </Paper>
              </Grid>
            ))}
          </Grid>
        </Container>
      </Box>
    </>
  );
}
